import { RouteProps } from '../../routes/AppRouter'
import { ClinicForm } from '../../features/clinics'
import { Title } from '../../components/common/Title'
import { useTranslation } from 'react-i18next'
import { useParams } from '@reach/router'
import { useEffect, useState } from 'react'
import { getClinicContainer } from '../../container/clinic-modules'
import { ClinicService } from '../../modules/clinics/services/ClinicService'
import { CLINIC_SERVICE_KEY } from '../../modules/clinics'
import { Clinic } from '../../modules/clinics/models/Clinic'

const clinicService = getClinicContainer().get<ClinicService>(CLINIC_SERVICE_KEY)

export const Form = (props: RouteProps) => {
  const { t } = useTranslation()
  const params = useParams()
  const [clinic, setClinic] = useState<Clinic>()
  const title = params && params.id === 'create' ? t('newClinic') : t('Edit')

  useEffect(() => {
    if (params.id === 'create') {
      return
    }
    clinicService.getByID(params.id).subscribe((value) => setClinic(value))
  }, [params.id])

  return (
    <>
      <Title color={props.color} title={title} />
      <ClinicForm clinic={clinic} />
    </>
  )
}
